import { createKeyedDataAsyncSlice } from '../createKeyedDataAsyncSlice';
import { getClientTitleAsync } from '../../API/clientPortal/clientTitleAPI';

export const { slice: getClientTitleSlice, asyncAction: getClientTitleAction } = createKeyedDataAsyncSlice(
  'getClientTitle',
  getClientTitleAsync,
  (orderId) => `${orderId}`
);
